import { Component, OnInit } from '@angular/core';
import { OnboardingStore } from '@boxx/onboarding-core/lib/state/onboarding.store';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { BottomSheetType } from '@app/components/bottom-sheet/bottom-sheet.model';
import { Platform } from '@ionic/angular';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import { Clipboard } from '@capacitor/clipboard';
import { Browser } from '@capacitor/browser';

@Component({
  selector: 'app-qr',
  templateUrl: './qr.component.html',
  styleUrls: ['./qr.component.scss'],
})
export class QRComponent implements OnInit {
  canOpenModalQR: boolean;
  isLoadingQR = true;
  destroyed$ = new Subject<boolean>();
  sites: any[];
  translations: any;
  currentLanguage: string = 'en';

  constructor(
    private translate: TranslateService,
    private onboardingStore: OnboardingStore,
    private utils: BoxxUtilsService,
    private platform: Platform,
    public storageService: LocalStorageNativeService
  ) {
    this.translate
    .get(['CLIPBOARD'])
    .pipe(takeUntil(this.destroyed$))
    .subscribe((t: any) => {
      this.translations = t;
    });
  }

  async ngOnInit() {
    this.onboardingStore.businessConfig.businessData$
    .pipe(takeUntil(this.destroyed$))
    .subscribe(async business => {
      if (!business) {
        return;
      }

      this.sites = business.sites;
      //this.validateSiteQR();
        if(business.sites !== undefined && business.sites.length > 0){
          this.canOpenModalQR = true;
          this.isLoadingQR = false;
        }
        else{
          setTimeout(() => {
            this.isLoadingQR = false;
          }, 5000);
        }

    });

    const language = await this.storageService.getItem('selectedLanguage');
    if (language || language !== null) {
        this.currentLanguage = language;
    }
  }

  async openQRComponent() {
    let siteSelected;
    let dataSites = [];
    this.sites.forEach(site => {
      if(site.type === 'agency_website' || site.type === 'website'){
        dataSites.push({
          key: site.type,
          value: 'TABS.qr.option_website',
          icon: 'QR_web',
          icon_type: 'src',
          class: 'custom',
          url: site.url
        });
      }
      else if(site.type === 'shop'){
        dataSites.push({
          key: 'shop',
          value: 'TABS.qr.option_store',
          icon: 'QR_store',
          icon_type: 'src',
          class: 'custom',
          url: site.url
        });
      }
      else if(site.type === 'directory'){
        dataSites.push({
          key: 'directory',
          value: 'TABS.qr.option_website',
          icon: 'QR_web',
          icon_type: 'src',
          class: 'custom',
          url: site.url
        });
      }
    });
    this.utils.openBottomSheet({
      data: [],
      site: dataSites,
      firstTimeOpen: true,
      type: BottomSheetType.qr,
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      canClose: true,
      title: '',
      maxHeigth: 80
    }).then((data: any) => {
      if (data?.value) {
        console.log('data: ', data)
        this. actionsSiteSelected(data?.value, data?.url);
      }
    });

    // if(this.sites.length > 1){
    //   this.utils.openBottomSheet({
    //     data: dataSites,
    //     type: BottomSheetType.options,
    //     initialBreakpoint: 1,
    //     breakpoints: [0, 1],
    //     canClose: true,
    //     title: '',
    //     maxHeigth: 30
    //   }).then((data) => {
    //     if (data?.value) {
    //       siteSelected = this.sites.find((site) => site.type === data?.value).url; 
    //       this.utils.openBottomSheet({
    //         data: [],
    //         site: this.sites.find((site) => site.type === data?.value),
    //         firstTimeOpen: true,
    //         type: BottomSheetType.qr,
    //         initialBreakpoint: 1,
    //         breakpoints: [0, 1],
    //         canClose: true,
    //         title: '',
    //         maxHeigth: 80
    //       }).then((data) => {
    //         if (data?.value) {
    //           this. actionsSiteSelected(data?.value, siteSelected);
    //         }
    //       });
    //     }
    //   });
    // }
    // else{
    //   this.utils.openBottomSheet({
    //     data: [],
    //     site: this.sites[0],
    //     firstTimeOpen: true,
    //     type: BottomSheetType.qr,
    //     initialBreakpoint: 1,
    //     breakpoints: [0, 1],
    //     canClose: true,
    //     title: '',
    //     maxHeigth: 80
    //   }).then((data) => {
    //     if (data?.value) {
    //       this. actionsSiteSelected(data?.value, this.sites[0].url);
    //     }
    //   });
    // }
  }

  async actionsSiteSelected(option: string, url: string){
    if(option === 'openUrl'){
      await Browser.open({ url });
      //Browser.open({ url: url, toolbarColor: 'primary', presentationStyle: 'fullscreen' });
     //window.open(url, '_blank');
    }
    else if(option === 'copyUrl'){
      if (this.platform.is('desktop') || this.platform.is('mobileweb')) {
        if (navigator.clipboard) {
          try {
            await navigator.clipboard.writeText(url).then(
              () => {
                this.utils.showToastSuccess({
                  message: this.currentLanguage === 'es' ? "URL copiada en el Portapapeles" : "URL copied to Clipboard"
                });
              },
              () => {
                this.utils.showToastError({
                  message: this.currentLanguage === 'es' ? "Ocurrió un error al intentar copiar la URL" : "An error occurred while trying to copy the URL"
                });
              }
            );
          } catch (err) {
            this.utils.showToastError({
              message: this.currentLanguage === 'es' ? "Ocurrió un error al intentar copiar la URL" : "An error occurred while trying to copy the URL"
            });
          }
        }
      } else {
        Clipboard.write({
          string: url
        }).then(
          () => {
            this.utils.showToastSuccess({
              message: this.translations.CLIPBOARD.urlCopiedToClipboard,
            });
          },
          () => {
            this.utils.showToastError({
              message: this.translations.CLIPBOARD.urlCopiedToClipboardError,
            });
          }
        );
      }
    }
  }


}
